import { Ionicons } from '@expo/vector-icons';
import { useNavigation, useRoute } from '@react-navigation/native';
import { get } from 'lodash';
import React, { useEffect } from 'react';
import { Image, ScrollView, TouchableOpacity, View } from 'react-native';
import { useHistoryDetailsQuery } from 'src/common/hooks';
import EchoSocket from 'src/common/utils/Socket';
import {
  ContactPersonCard,
  Container,
  EmptyState,
  IconButton,
  PrimaryButton,
  RegularText,
  SizedBox,
} from 'src/components';
import { RatingAndReviewModal } from 'src/components/layout/RatingAndReviewModal';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';
import { BusDetailsCard } from './components/BusDetailsCard';
import { PassengerDetailsCard } from './components/PassengerDetailsCard';
import { PaymentBreakdownCard } from './components/PaymentBreakdownCard';
import { QRCodeTicket } from './components/QRCodeTicket';
import { TicketForShare } from './components/TIcketForShare';

const MyTicketScreen = () => {
  const qrCodeTicketRef = React.useRef();
  const { params } = useRoute<any>();
  const [ticketStatus] = React.useState<number>(0);
  const [ticketTabbar, setTicketTabbar] = React.useState<number>(0);
  const [isRating, setRating] = React.useState<boolean>(false);
  const navigation = useNavigation();

  const { data, isFetching, isError, refetch, error } = useHistoryDetailsQuery(params.bookingId || '0');

  // const [activity] = React.useState<'share' | 'download' | ''>('');
  // const [isShare, setShare] = React.useState(true);
  const [isShare, setShare] = React.useState(false);

  useEffect(() => {
    if (!data?.paymentChannel) return () => {};
    window?.nham24?.request('consolelog', { channel: data.paymentChannel });

    const unsubscription = EchoSocket.refreshPayment(data.paymentChannel, () => {
      window?.nham24?.request('consolelog', 'socket has been trigger');
      refetch();
    });

    return () => {
      unsubscription();
    };
  }, [data]);

  useEffect(() => {
    const headerRight = () => {
      if (data?.reservations[ticketTabbar].status === 'Upcoming') {
        return (
          <IconButton
            style={{
              height: pixelScaler(34),
              width: pixelScaler(34),
              alignItems: 'center',
              justifyContent: 'center',
            }}
            icon={<Ionicons size={pixelScaler(26)} name="share-outline" color={AppColors.white} />}
            onPress={handleShareTicket}
          />
        );
      }
      if (data?.reservations[ticketTabbar].status === 'Departed') {
        return (
          <TouchableOpacity
            activeOpacity={0.8}
            style={{
              flexDirection: 'row',
              backgroundColor: AppColors.white,
              borderRadius: 50,
              paddingHorizontal: metrics.large,
              paddingVertical: metrics.small,
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onPress={() => {
              if (window?.nham24) window.nham24.request('app/navigate', { screen: 'TaxiHomeScreen', params: {} });
            }}>
            <Image
              source={{ uri: 'https://imagery.go24.tech/media/upload/ServiceCategories/0221104124745107.png' }}
              style={{ height: 24, width: 24, marginRight: metrics.small }}
              resizeMode="contain"
            />
            <RegularText textLang="bookARide" />
          </TouchableOpacity>
        );
      }
      return null;
    };

    navigation.setOptions({
      headerRight,
    });
  }, [data?.reservations[ticketTabbar]]);

  // React.useEffect(() => {
  //   if (!image) return;

  //   console.log(image);

  //   // if (activity === 'share') {
  //   if (window?.nham24?.request) {
  //     // need to inject from react-native side
  //     window.nham24.request('app/share', { title: "This is my nham24's ticket", url: image });
  //   }
  //   // return;
  //   // }
  //   // if (activity === 'download') {
  //   // const Base64Code = image.split('data:image/png;base64,'); // base64Image is my image base64 string
  //   // const { dirs } = RNFetchBlob.fs;
  //   // const path = `${dirs.DCIMDir}/image.png`;
  //   // RNFetchBlob.fs.writeFile(path, Base64Code[1], 'base64').then(res => {
  //   //   console.log('File : ', res);
  //   // });
  //   // }
  // }, [image, activity]);

  useEffect(() => {
    refetch();
  }, [ticketStatus]);

  // const handleDownloadImagePress = () => {
  //   setActivity('');
  //   setActivity('download');
  // };

  const handleShareTicket = () => {
    setShare(true);
    // takeScreenshot(qrCodeTicketRef.current);
    // // console.log(image);
    // if (image) {
    //   if (window?.nham24?.request) {
    //     // need to inject from react-native side
    //     window.nham24.request('app/share', { title: "This is my nham24's ticket", url: image });
    //   }
    // }
  };

  const handleRateTripPress = () => {
    setRating(true);
  };

  if (isFetching || isError) {
    return <EmptyState loading={isFetching} error={error} text="tripEmptyContent" />;
  }

  const reservation = data?.reservations[ticketTabbar];

  if (!reservation) return <View />;

  return (
    <Container backgroundColor={AppColors.backgroundColor} flex>
      <ScrollView showsVerticalScrollIndicator={false} style={{ flex: 1 }}>
        <QRCodeTicket
          ref={qrCodeTicketRef}
          setTicketTabbar={setTicketTabbar}
          ticketTabbar={ticketTabbar}
          ticket={{
            seats: reservation.seats,
            qrcodeData: reservation.reservationId,
            date: reservation.departureDate,
            seatCount: reservation.seatCount,
            status: reservation.status,
            time: reservation.departureTime,
            canRating: reservation.canRating,
            remaining: `${reservation.checkedInSeatsCount}/${reservation.passengers.length}`,
            checkedInSeatsCount: reservation.checkedInSeatsCount,
          }}
          reservationsLength={get(data, 'reservations.length', 0)}
        />
        <SizedBox />
        <Container padding={metrics.large} paddingTop={0}>
          <BusDetailsCard
            service={data?.service}
            operator={reservation.operator}
            amenities={reservation.amenities || []}
            transits={reservation.transits || []}
          />
          <SizedBox />
          <PassengerDetailsCard passengers={reservation.passengers || []} />
          <SizedBox />
          <ContactPersonCard email={data?.contactEmail} name={data?.contactName} phone={data?.contactPhone || ''} />
          <SizedBox />
          <PaymentBreakdownCard isReturnTrip={ticketTabbar === 1} payment={data?.payment} reservation={reservation} />
          {isRating && (
            <RatingAndReviewModal
              operatorId={`${reservation.operator.id}`}
              reservationId={reservation.reservationId}
              isVisible={isRating}
              onClose={() => setRating(false)}
            />
          )}
        </Container>
      </ScrollView>
      {/* {reservation.status === 'Departed' && (
        <Container padding={metrics.large} backgroundColor={AppColors.white}>
        <PrimaryButton text="review" onPress={handleRateTripPress} />
        </Container>
      )} */}

      {reservation.status === 'Departed' && reservation.canRating && (
        <Container
          style={{ borderTopWidth: 1, borderColor: AppColors.border }}
          padding={metrics.large}
          backgroundColor={AppColors.white}>
          <PrimaryButton
            backgroundColor={AppColors.primary}
            style={{ borderRadius: 40, borderColor: AppColors.primary, shadowColor: 'transparent' }}
            text="rateTrip"
            onPress={handleRateTripPress}
          />
        </Container>
      )}
      {isShare && (
        <TicketForShare
          onClose={() => setShare(false)}
          service={data?.service}
          reservation={reservation}
          isVisible={isShare}
        />
      )}
    </Container>
  );
};

export default MyTicketScreen;
